import styled from 'styled-components';

export const CookieAlert = styled.div`
  bottom: 0;
  left: 0;
  width: 100%;
  position: fixed;
  z-index: 998;
  background-color: rgba(0, 0, 0, 0.85);

  -webkit-transition: all 0.5s ease-out;
  -moz-transition: all 0.5s ease-out;
  -o-transition: all 0.5s ease-out;
  transition: all 0.5s ease-out;

  & > :first-child {
    padding: 1rem 3rem;
    margin: 0 auto;
    max-width: 1220px;
    color: #fff;
    font-size: 1.4rem;

    h1 {
      font-size: 1.8rem;
      text-align: center;
      margin-bottom: 1rem;
    }

    a {
      color: ${(props) => {
		if (props.program === 'cnhforall') return '#0079c1';
		if (props.program === 'cnhpop') return '#1EAB61';
		return '#a0ced8';
	}};
    }

    a:hover {
      text-decoration: underline;
    }

    div {
      display: flex;
      justify-content: center;
      width: 100%;
      margin-top: 1rem;

      button {
        margin: 0 auto;
        background-color: ${(props) => {
		if (props.program === 'cnhforall') return '#0079c1';
		if (props.program === 'cnhpop') return '#1EAB61';
		return '#a0ced8';
	}};
        padding: 8px 20px;
        border: none;
        border-radius: 5px;
        color: #fff;
        font-weight: 900;
        -webkit-transition: opacity 0.2s;
        transition: opacity 0.2s;
      }
    }
  }
`;
